"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transaction = void 0;
const class_validator_1 = require("class-validator");
const property_1 = require("../../decorators/property");
const mocks_1 = require("../../mocks");
const constants_1 = require("../../constants");
class IssuerType {
}
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, required: false, index: true }),
    __metadata("design:type", String)
], IssuerType.prototype, "id", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.IssuerTypeEnum }),
    __metadata("design:type", String)
], IssuerType.prototype, "type", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], IssuerType.prototype, "name", void 0);
class Transaction extends mocks_1.Model {
}
exports.Transaction = Transaction;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Transaction.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ type: String, enum: constants_1.TransactionTypeEnum, index: true }),
    __metadata("design:type", String)
], Transaction.prototype, "type", void 0);
__decorate([
    (0, property_1.Property)({ type: IssuerType }),
    __metadata("design:type", IssuerType)
], Transaction.prototype, "issuer", void 0);
__decorate([
    (0, property_1.Property)({ type: IssuerType }),
    __metadata("design:type", IssuerType)
], Transaction.prototype, "receiver", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ default: '' }),
    __metadata("design:type", String)
], Transaction.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)({ required: false, allowMixed: 0 }),
    __metadata("design:type", Object)
], Transaction.prototype, "extraData", void 0);
